<template>
  <draggable
    :value="localValue"
    :group="group"
    class="v-treeview v-treeview-draggable"
    :class="themeClassName"
    ghost-class="ghost"
    @input="updateValue"
    :options="{ disabled }"
    handle=".capture-area"
  >
    <draggable-tree-view-node
      v-for="item in value"
      :key="item.Id"
      :group="group"
      :value="item"
      :expand-icon="expandIcon"
      @input="updateItem"
      :isOpen="opens.has(item.Id)"
      :opens="opens"
      :updateItems="updateItems"
      v-on="$listeners['clickRow'] ? { clickRow: $listeners['clickRow'] } : {}"
      :pageEditName="pageEditName"
    >
      <template v-slot:prepend="{ item, open }">
        <slot name="prepend" v-bind="{ item, open }"> </slot>
      </template>
      <template v-slot:label="{ item, open }">
        <slot name="label" v-bind="{ item, open }"> </slot>
      </template>
      <template v-slot:append="{ item, open }">
        <slot name="append" v-bind="{ item, open }"> </slot>
      </template>
      <template v-slot:captureArea="{ item, open }">
        <slot name="captureArea" v-bind="{ item, open }"> </slot>
      </template>
    </draggable-tree-view-node>
  </draggable>
</template>

<script>
import Vue from "vue";
import draggable from "vuedraggable";
import DraggableTreeViewNode from "./DraggableTreeviewNode.vue";
export default Vue.extend({
  name: "view-DraggableTreeview",
  components: {
    draggable,
    DraggableTreeViewNode,
  },
  props: {
    opens: {
      type: Set,
      default: () => new Set(),
    },
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    group: {
      type: String,
      default: null,
    },
    expandIcon: {
      type: String,
      default: "mdi-menu-down",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    updateItems: {
      type: Function,
    },
    pageEditName: {
      type: String,
    },
  },
  data() {
    return {
      localValue: [...this.value],
    };
  },
  computed: {
    themeClassName() {
      return this.$vuetify.theme.isDark ? "theme--dark" : "theme--light";
    },
  },
  watch: {
    value(value) {
      this.localValue = [...value];
    },
  },
  methods: {
    updateValue(value) {
      // Обновление ParentId
      var addParentId = (items, parentId) => {
        for (const j in items) {
          items[j].ParentId = parentId;

          if (items[j].Children.length !== 0)
            addParentId(items[j].Children, items[j].Id);
        }
      };
      setTimeout(() => {
        addParentId(value, null);
      }, 100);

      this.localValue = value;
      this.$emit("input", this.localValue);
    },
    updateItem(itemValue) {
      const index = this.localValue.findIndex((v) => v.Id === itemValue.Id);
      this.$set(this.localValue, index, itemValue);
      this.$emit("input", this.localValue);
    },
  },
});
</script>
